module.exports = __webpack_public_path__ + "fonts/Play-Exchange-Icons.a428626.woff";